export default function PHP_Comments() {
  return (
    <div>
      <h1>PHP_Comments</h1>
    </div>
  );
}
